import { BrowserRouter, Route, Routes } from "react-router-dom";
import AuthProvider from "../context/AuthProvider";
import Home from "../pages/Home";
import Login from "../pages/Login";
import HowItWorks from "../pages/HowItWorks";
import Checkout from "../pages/Checkout";
import NotFound from "../pages/NotFound";
import CreateAccount from "../pages/CreateAccount";
import GlobalProvider from "../context/GlobalProvider";
import PrivacyPolicy from "../pages/PrivacyPolicy";
import TermsOfService from "../pages/TermsOfService";
import { Private } from "../utils/Private";
import ConfirmCode from "../pages/ConfirmCode";
import ResetPassword from "../pages/ResetPassword";
import ResetPasswordForm from "../pages/ResetPasswordForm";
import DeleteAccountInfo from "../pages/DeleteAccountInfo";
import Support from "../pages/Support";
import Plans from "../pages/Plans";
import Dashboard from "../pages/Dashboard";
import DownloadApp from "../pages/DownloadApp";
import DeleteAccount from "../pages/DeleteAccount";
import Ebook from "../pages/Ebook";
import Welcome from "../pages/Welcome";

const AllRoutes = () => {

    return (
        <BrowserRouter>
            <GlobalProvider>
                <AuthProvider>
                    <Routes>
                        {/*Rotas publicas do fonotherapp*/}
                        <Route path="/" element={<Home />} />
                        <Route path="/login" element={<Login />} />
                        <Route path="/como-funciona" element={<HowItWorks />} />
                        <Route path="*" element={<NotFound />} />
                        <Route path="/cadastro" element={<CreateAccount />} />

                        {/*Rotas privadas do fonotherapp*/}
                        {<Route path="/planos" element={<Private> <Plans /> </Private>} />}
                        <Route path="/checkout" element={<Private><Checkout /></Private>} />
                        {<Route path="/dashboard" element={<Private><Dashboard /></Private>} />}

                        {/*Rotas publicas para politica de privacidade e termos de serviço*/}
                        <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
                        <Route path="/termos-e-servicos" element={<TermsOfService />} />

                        {/*Rotas publicas para recuperar senha*/}

                        <Route path="/recuperar-senha" element={<ResetPassword />} />
                        <Route path="/confirmar-codigo" element={<ConfirmCode />} />
                        <Route path="/alterar-senha" element={<ResetPasswordForm />} />
                        {/*Rotas publicas para informar como deletar a conta*/}
                        <Route path="/ajuda/deletar-conta" element={<DeleteAccountInfo />} />
                        <Route path="/suporte" element={<Support />} />
                        <Route path="/download-app" element={<Private> <DownloadApp /> </Private>} />
                        <Route path="/apagar-conta" element={<Private> <DeleteAccount /> </Private>} />
                        
                        <Route path="/ebook" element={<> <Ebook /> </>} />
                        <Route path="/baixar-ebook" element={<> <Welcome /> </>} />

                    </Routes>
                </AuthProvider>
            </GlobalProvider>

        </BrowserRouter>
    );
};
export default AllRoutes;